import React from "react";
import { Col } from "reactstrap";

const SegmentedProgressBar = ({ title, value, count = 9 }) => {
  const filledSegments = Math.min(
    count,
    Math.max(0, Math.round(Number(value) || 0)),
  );
  const isNotNumber = isNaN(value);
  const score = isNotNumber ? `0/${count}` : `${filledSegments}/${count}`;

  return (
    <Col lg>
      <div className="p-3 bg-white rounded-3 border border-light-subtle shadow-sm h-100 d-flex flex-column justify-content-center">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="fw-semibold text-muted" style={{ fontSize: "13px" }}>
            {title}
          </span>
          <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
            {score}
          </span>
        </div>
        <div className="d-flex align-items-center gap-1 w-100">
          {Array.from({ length: count }).map((_, index) => (
            <span
              key={index}
              className="flex-fill rounded-pill"
              style={{
                height: "8px",
                backgroundColor:
                  index < filledSegments ? "#38bdf8" : "#e2e8f0",
                transition: "background-color 0.3s ease",
              }}
            />
          ))}
        </div>
      </div>
    </Col>
  );
};

export default SegmentedProgressBar;
